import type { ReactNode } from "react";
export enum CarSelfServeModalType {
  Cancel,
  ResendEmail,
  ContactSupport,
  Invoice,
}

export type CarItineraryActionMapType = Partial<
  Record<CarSelfServeModalType, ReactNode>
>;

export interface ActionLink {
  content: ReactNode;
  modalType: CarSelfServeModalType;
  onClick?: () => void;
}
